/* Custom JavaScript for Cosylabs Theme */

function initAll() {
  initColorPickerScroll();
  // styleChooseColourLabel removed - no integration needed
}

// Run when DOM is ready with multiple attempts
function tryInit() {
  const groupmateContainer = document.querySelector('.mw_groupmate__container');
  if (groupmateContainer) {
    initAll();
  } else {
    // Retry after a short delay
    setTimeout(tryInit, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(tryInit, 300);
  });
} else {
  setTimeout(tryInit, 300);
}

// Also watch for dynamically added content
const observer = new MutationObserver(function(mutations) {
  const groupmateContainer = document.querySelector('.mw_groupmate__container');
  if (groupmateContainer && !groupmateContainer.dataset.customInitialized) {
    groupmateContainer.dataset.customInitialized = 'true';
    setTimeout(initAll, 100);
  }
});

// Only observe if container doesn't exist yet
if (!document.querySelector('.mw_groupmate__container')) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function styleChooseColourLabel() {
  // Function removed - keeping "Choose Colour" as separate text block
  // No integration needed
}

// Helper function to update arrow visibility
function updateArrowVisibilityForList(container, list) {
  const header = container.querySelector('.color-picker-header');
  if (!header) return;
  const leftBtn = header.querySelector('.color-picker-arrow--left');
  const rightBtn = header.querySelector('.color-picker-arrow--right');
  if (!leftBtn || !rightBtn) return;
  
  const scrollLeft = list.scrollLeft;
  const maxScroll = list.scrollWidth - list.clientWidth;
  
  leftBtn.disabled = scrollLeft <= 10;
  rightBtn.disabled = scrollLeft >= maxScroll - 10;
}

function initColorPickerScroll() {
  const container = document.querySelector('.mw_groupmate__container');
  const swatchList = document.querySelector('.mw_groupmate__swatchlist');
  
  if (!container || !swatchList) return;
  
  // Check if header already exists - prevent duplicates
  if (container.querySelector('.color-picker-header')) {
    // If header exists, just update arrow visibility
    updateArrowVisibilityForList(container, swatchList);
    return;
  }
  
  // Mark as initialized to prevent duplicate creation
  container.dataset.customInitialized = 'true';
  
  // Create header section
  const header = document.createElement('div');
  header.className = 'color-picker-header';
  
  // Create "Choose Colour" title
  const title = document.createElement('div');
  title.className = 'color-picker-title';
  title.textContent = 'Choose Colour';
  
  // Create arrows container
  const arrowsContainer = document.createElement('div');
  arrowsContainer.className = 'color-picker-arrows';
  
  // Create left arrow
  const leftArrow = document.createElement('button');
  leftArrow.className = 'color-picker-arrow color-picker-arrow--left';
  leftArrow.innerHTML = '&lt;';
  leftArrow.setAttribute('aria-label', 'Scroll left');
  leftArrow.type = 'button';
  
  // Create right arrow
  const rightArrow = document.createElement('button');
  rightArrow.className = 'color-picker-arrow color-picker-arrow--right';
  rightArrow.innerHTML = '&gt;';
  rightArrow.setAttribute('aria-label', 'Scroll right');
  rightArrow.type = 'button';
  
  // Assemble header
  arrowsContainer.appendChild(leftArrow);
  arrowsContainer.appendChild(rightArrow);
  header.appendChild(title);
  header.appendChild(arrowsContainer);
  
  // Insert header at the beginning of container
  container.insertBefore(header, container.firstChild);
  
  // Scroll functionality
  const scrollAmount = 220;
  
  leftArrow.addEventListener('click', function(e) {
    e.preventDefault();
    swatchList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
  
  rightArrow.addEventListener('click', function(e) {
    e.preventDefault();
    swatchList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
  
  // Update arrow visibility based on scroll position
  function updateArrowVisibility() {
    const scrollLeft = swatchList.scrollLeft;
    const maxScroll = swatchList.scrollWidth - swatchList.clientWidth;
    
    if (scrollLeft <= 10) {
      leftArrow.disabled = true;
    } else {
      leftArrow.disabled = false;
    }
    
    if (scrollLeft >= maxScroll - 10) {
      rightArrow.disabled = true;
    } else {
      rightArrow.disabled = false;
    }
  }
  
  swatchList.addEventListener('scroll', updateArrowVisibility);
  window.addEventListener('resize', updateArrowVisibility);
  
  // Initial check
  setTimeout(updateArrowVisibility, 100);
}

